import { supabase } from '@/integrations/supabase/client';
import { getBrowser, getPlatform, deviceLabel } from '@/pwa/installContext';

const sb = supabase as any;

export type InstallEvent =
  | 'screen_shown' | 'install_click' | 'install_accepted' | 'install_dismissed'
  | 'continue_browser' | 'installed_hint_shown';

export async function trackInstallEvent(userId: string | undefined, event: InstallEvent) {
  if (!userId) return;
  try {
    await sb.from('pwa_install_events').insert({ user_id: userId, event, platform: getPlatform(), browser: getBrowser() });
  } catch { /* medição nunca bloqueia */ }
}

export async function recordStandaloneOpen() {
  try { await sb.rpc('pwa_record_standalone', { _platform: getPlatform(), _device_label: deviceLabel() }); } catch { /* ignore */ }
}

/** A conta já abriu o app instalado neste tipo de aparelho? */
export async function hasInstalledOnPlatform(userId: string): Promise<boolean> {
  try {
    const { data } = await sb.from('pwa_installs').select('id').eq('user_id', userId).eq('platform', getPlatform()).maybeSingle();
    return !!data;
  } catch { return false; }
}
